import React, { Component } from "react";
import {
  Layout,
  Input,
  Row,
  Col,
  notification,
  message,
  Checkbox,
  //Button
} from "antd";
import {
  ArrowLeftOutlined,
  ExclamationCircleFilled,
  FacebookOutlined,
  InstagramOutlined,
  LinkedinOutlined,
  LockOutlined,
  SafetyCertificateOutlined,
  TikTokOutlined,
  UserOutlined,
  WhatsAppOutlined,
  XOutlined,
  YoutubeOutlined,
} from "@ant-design/icons";
//import Building from "../../Icons/Building";
import logoB from "../../assets/Biwo_bienvenida.png";
import logoGrande from "../../assets/Biwo logo grande.png";
import bienvenidaLogin from "../../assets/Bienvenida-Banner-Biwo.png";
import hechoEnMexico from "../../assets/hecho_en_mexico.png";
import { NavLink } from "react-router-dom";
import { login, loginDosPasos, hasSigned } from "../../store/actions/user";
import { connect } from "react-redux";
import { Form, FormItem, ButtonItem, ErrorItem } from "../../Components/Items";
import axios from "axios";

const { Content } = Layout;

const urlContent = process.env.NODE_ENV === "development" ? `http://192.168.100.83:3000` : "https://biwo.online";

class LogIn extends Component {
  state = {
    loading: false,
    imagenUrl:  `${urlContent}/Apariencia/login/Bienvenida-Banner-Biwo.png`,
    videoUrl: null,
    tipoMedia: "imagen",
    textoGlass: "",
    mostrarCard: true,
    requiereDosPasos: false,
    errorDosPasos: null,
    intentosDosPasos: 0,
  };

  componentDidMount() {

    const defaultImage = `${urlContent}/Apariencia/login/Bienvenida-Banner-Biwo.png`
    const defaultVideo = `${urlContent}/Apariencia/login/Bienvenida-Video-Login.mp4`

    axios.post("apariencia/obtenerConfiguracionLoginPublico", {})
      .then((res) => {
        const config = res.data;
        this.setState({
          imagenUrl: defaultImage + "?t=" + Date.now(),
          videoUrl: config.tieneVideo ? defaultVideo + "?t=" + Date.now() : null,
          tipoMedia: config.tipoMedia || "imagen",
          textoGlass: config.textoGlass || "",
          mostrarCard: config.mostrarGlass !== false,
        });
      })
      .catch((err) => {
        console.warn("Cargando config por defecto", err);
        this.setState({
          imagenUrl: defaultImage + "?t=" + Date.now(),
          mostrarCard: true,
        });
      });
  }

  onFinish(values) {
    this.setState({ loading: true });
    this.props
      .login(values)
      .then((data) => this.procesarLogin(data))
      .catch((err) => this.errorLogin(err));
  }

  onFinishDosPasos(values) {
    if (!String(values.codigo || "").trim()) {
      return this.setState((estado) => ({ errorDosPasos: "Escribe tu código de verificación.", intentosDosPasos: estado.intentosDosPasos + 1 }));
    }
    this.setState({ loading: true, errorDosPasos: null });
    this.props
      .loginDosPasos({ codigo: values.codigo, confiarDispositivo: values.confiarDispositivo === true })
      .then((data) => this.procesarLogin(data))
      .catch((err) => this.errorLogin(err));
  }

  procesarLogin(data) {
        this.setState({ loading: false });
        if (data?.requiereDosPasos) {
          this.setState((estado) => ({ requiereDosPasos: true, errorDosPasos: data.err || null, intentosDosPasos: estado.intentosDosPasos + 1 }));
        } else if (data?.success === 1) {
          message.info("Bienvenido " + data.nombre);
          this.props.history.push("/panelPrincipal");
        } else {
          message.warning(data.err);
          if (data?.redirigir) {
            message.info("Serás redirigido en unos segundos...");
            setTimeout(() => {
              window.location.replace(data.redirigir);
            }, 5000);
          }
          if (this.state.requiereDosPasos) this.setState({ requiereDosPasos: false, errorDosPasos: null });
        }
  }

  errorLogin(err) {
    this.setState({ loading: false });
    notification.error({
      message: "Error inesperado",
      description: err.toString(),
      duration: 1.5,
    });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    //const current = this.props.history.location.pathname;
    return (
      <Layout id="login-layout">
        <Content>
         
            <Row id="login-row">

              {/* Imagen*/}
              <Col xs={0} sm={0} lg={13} xl={13} id="login-col-imagen">
                <div id="login-imagen-card">
                  {this.state.tipoMedia === "video" && this.state.videoUrl ? (
                    <video
                      src={this.state.videoUrl}
                      id="login-imagen"
                      poster={this.state.imagenUrl}
                      autoPlay
                      loop
                      muted
                      playsInline
                      preload="auto"
                      style={{ objectFit: "cover" }}
                      onError={() => { this.setState({ tipoMedia: "imagen" }); }}
                    />
                  ) : (
                    <img
                      src={this.state.imagenUrl}
                      alt="Biwo"
                      id="login-imagen"
                      onError={(e) => { e.target.src = bienvenidaLogin; }}
                    />
                  )}
                   {this.state.mostrarCard && (
                    <div className="login-glass-card">
                      {this.state.textoGlass ? (
                        <p
                          className="login-glass-text"
                          dangerouslySetInnerHTML={{ __html: this.state.textoGlass }}
                        />
                      ) : (
                        <p className="login-glass-text">
                          Transforma cada desafío en una{" "} oportunidad con nuestro <span className="login-glass-highlight">ERP</span> : organiza, optimiza y avanza hacia el éxito con
                          confianza
                        </p>
                      )}
                    </div>
                   )}
                </div>
              </Col>

              {/* Formulario */}
              <Col xs={24} sm={24} lg={11} xl={11} id="login-col-form">
                <div className="login-form-container">

                  <div className="login-header-section" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                    <h1 style={{ color: '#36B9D0', marginBottom: '-110px', fontWeight: 'bold', fontSize: '50px' }}>Bienvenido a</h1>
                    <img src={logoB} alt="Biwo" className="login-logo-desktop" style={{ width: '32.0rem', marginTop: '20px' }} />
                    <img src={logoGrande} alt="Biwo" className="login-logo-mobile" style={{ marginTop: '15px', marginBottom: '50px' }} />
                  </div>

                  {this.state.requiereDosPasos ? (
                  <Form
                    defaultBehavior
                    name="loginDosPasos"
                    initialValues={{ confiarDispositivo: true }}
                    onFinish={this.onFinishDosPasos.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                  >
                    <p style={{ textAlign: "center", color: "#555", marginBottom: 16 }}>
                      Escribe el código de 6 dígitos de tu app Google Authenticator o Microsoft Authenticator.
                    </p>
                    <FormItem name="codigo" style={{ marginBottom: this.state.errorDosPasos ? 8 : undefined }}>
                      <Input
                        placeholder="Código de verificación"
                        prefix={<SafetyCertificateOutlined style={{ color: "#94a3b8" }} />}
                        size="large"
                        maxLength={20}
                        autoComplete="one-time-code"
                        autoFocus
                        className={this.state.errorDosPasos ? "login-input login-input-error" : "login-input"}
                        onChange={() => this.state.errorDosPasos && this.setState({ errorDosPasos: null })}
                      />
                    </FormItem>
                    {this.state.errorDosPasos && (
                      <div className="login-dos-pasos-error" key={this.state.intentosDosPasos}>
                        <ExclamationCircleFilled />
                        <span>{this.state.errorDosPasos}</span>
                      </div>
                    )}
                    <FormItem name="confiarDispositivo" valuePropName="checked" style={{ marginBottom: 8 }}>
                      <Checkbox>Confiar en este dispositivo por 30 días</Checkbox>
                    </FormItem>
                    <FormItem style={{ marginTop: "0", marginBottom: "4px" }}>
                      <ButtonItem htmlType="submit" type="primary" cyan loading={this.state.loading}
                        style={{
                          height: "44px",
                          width: "100%",
                          fontSize: "18px",
                          fontWeight: "600",
                        }}
                      >
                        Verificar
                      </ButtonItem>
                    </FormItem>
                    <p style={{ textAlign: "center", color: "#888", fontSize: 12, marginTop: 12 }}>
                      ¿No tienes tu celular? Escribe uno de tus códigos de respaldo.
                    </p>
                    <ButtonItem blanco className="login-volver" icon={<ArrowLeftOutlined />} onClick={() => this.setState({ requiereDosPasos: false, errorDosPasos: null })} style={{ width: "100%" }}>
                      Volver
                    </ButtonItem>
                  </Form>
                  ) : (
                  <Form
                    defaultBehavior
                    name="login"
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                  >

                  {/*<FormItem name="empresa" pattern required max={100} min={5}>
                    <Input
                      placeholder="Empresa"
                      prefix={<Building style={{ color: "#94a3b8" }} />}
                      size="large"
                      maxLength={100}
                    />
                    </FormItem>*/}


                    <FormItem name="usuario" pattern required max={100} min={5}>
                      <Input
                        placeholder="Correo o usuario"
                        prefix={<UserOutlined style={{ color: "#94a3b8" }} />}
                        size="large"
                        className="login-input"
                        maxLength={100}
                      />
                    </FormItem>
                    <FormItem name="password" pattern required max={50} min={5}>
                      <Input.Password
                        placeholder="Contraseña"
                        prefix={<LockOutlined style={{ color: "#94a3b8" }} />}
                        size="large"
                        className="login-input"
                        maxLength={50}
                      />
                    </FormItem>

                    <div className="login-forgot-link">
                      <NavLink to="/recuperarContrasena">
                        ¿Olvidaste tu contraseña?
                      </NavLink>
                    </div>

                    <FormItem style={{ marginTop: "0", marginBottom: "4px" }}>
                       <ButtonItem htmlType="submit" type="primary" cyan
                       style={{
                          height: "44px",
                          width: "100%",
                          fontSize: "18px",
                          fontWeight: "600",
                        }}
                       >
                        Entrar
                      </ButtonItem>
                    </FormItem>
                    
                     {<FormItem noStyle>
                      <Row
                        type="flex"
                        justify="center"
                        align="middle"
                        style={{ width: "100%", textAlign: "center", marginTop: "8px" }}
                      >
                        
                      {/* <h3 style={{ margin: 0, fontWeight: 400, fontSize: "14px", color: "#555" }}>¿No tienes cuenta?</h3> 
                          <Button type="link" style={{ padding: "0 4px" }}>
                            <NavLink to="/registro" style={{ color: "#00BFD6", fontWeight: 800 }}>Regístrate</NavLink>
                          </Button>
                        */}
                      </Row>
                    </FormItem>}

                  </Form>
                  )}
           
                  <div className="login-bottom-section">
                  <hr className="login-divider" />

                  <div className="login-social-row">
                    <a href="https://www.facebook.com/biwoerp" target="_blank" rel="noopener noreferrer">
                      <FacebookOutlined style={{ fontSize: "18px", color: "#3b5998" }} />
                    </a>
                    <a href="https://www.instagram.com/biwo_erp" target="_blank" rel="noopener noreferrer">
                      <InstagramOutlined style={{ fontSize: "18px", color: "#e1306c" }} />
                    </a>
                    <a href="https://www.linkedin.com/company/erp-biwo" target="_blank" rel="noopener noreferrer">
                      <LinkedinOutlined style={{ fontSize: "18px", color: "#0077b5" }} />
                    </a>
                    <a href="https://x.com/ERP_BIWO" target="_blank" rel="noopener noreferrer">
                      <XOutlined style={{ fontSize: "18px", color: "#000" }} />
                    </a>
                    <a href="https://www.tiktok.com/@biwo_erp" target="_blank" rel="noopener noreferrer">
                      <TikTokOutlined style={{ fontSize: "18px", color: "#000" }} />
                    </a>
                    <a href="https://wa.me/524448923732" target="_blank" rel="noopener noreferrer">
                      <WhatsAppOutlined style={{ fontSize: "18px", color: "#25D366" }} />
                    </a>
                    <a href="https://www.youtube.com/@BiwoERP" target="_blank" rel="noopener noreferrer">
                      <YoutubeOutlined style={{ fontSize: "18px", color: "#FF0000" }} />
                    </a>
                  </div>

                  <div className="login-legal">
                    <p>
                      Consulta los{" "}
                      <a href="/terminosYCondiciones" target="_blank" rel="noopener noreferrer">Términos y Condiciones</a>,{" "}
                      <a href="/avisoDePrivacidad" target="_blank" rel="noopener noreferrer">Aviso de Privacidad</a>,{" "}
                      <a href="/politicaCancelacion" target="_blank" rel="noopener noreferrer">Política de Cancelación y Devolución</a>, y{" "}
                      <a href="/condicionesServicioWhatsApp" target="_blank" rel="noopener noreferrer">Condiciones del Servicio de WhatsApp</a>.
                    </p>
                  </div>

                  {/* Sello + copyright centrados, debajo de los términos */}
                  <div className="login-corner-footer">
                    <img src={hechoEnMexico} alt="Hecho en México" style={{ width: '37px', opacity: 0.88 }} />
                    <span>Biwo ©2026</span>
                  </div>

                  </div>
                </div>
              </Col>

            </Row>
        </Content>
      </Layout>
    );
  }
}

export default connect(null, { login, loginDosPasos, hasSigned })(LogIn);
